export const defaultPageSize = 10;
export const defaultPageSizes = [5, 10, 15, 50, 100];